// @ts-check
// Modo foco (spec-2.0.0 seção 5.3; [FLX 20.4]): o editor de fluxo ocupa a tela inteira, sem o menu lateral nem a barra
// flutuante do celular, como no RD Station. Os diálogos globais continuam. Desde a 3.0.0 o editor dos bots também (contrato
// de bots, seção 22), sobre o mesmo canvas dos fluxos.

const FOCUS_LAYOUT_ROUTES = new Set(['automationFlowDetail', 'serviceBotDetail']);

/** A rota abre em modo foco? @param {string} routeName */
export function isFocusLayoutRoute(routeName) {
  return FOCUS_LAYOUT_ROUTES.has(routeName);
}
